<template>
  <div>

    <editDetailsModal v-if="modalData && modalData.type === 'drugs'"
                      :modalData="modalData"
                      :onModalClose="closeModal"
                      :onModalAccept="updateOrderDetailsByType"
    />

    <addCommentModal v-if="modalData && (modalData.type === 'comment' || modalData.type === 'reject')"
                     :modalData="modalData"
                     :onModalClose="closeModal"
                     :onModalAccept="() => addComment(modalData.comment, modalData.type)"
    />

    <addCommentModal v-if="modalData && modalData.type === 'status'"
                     :modalData="modalData"
                     :onModalClose="closeModal"
                     :onModalAccept="() => updateStatus(modalData.order)"
    />

    <table class="table table-sm table-bordered table-hover orders_profile_table">
      <thead>
      <tr>
        <th></th>
        <th>ID</th>
        <th>Клиент</th>
        <th>Адрес</th>
        <th>Препараты</th>
        <th>Комментарий</th>
        <th>Сумма</th>
        <th width="90"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(order, index) in orders" v-if="order">
        <td>
          <input v-if="permissions.allowToSelect" type="checkbox" v-model="selected[order.id]">
        </td>
        <td>
          <strong>{{ index + 1 }}</strong> ({{ order.id }})
          <p class="text-muted">{{ printDate(order.created_at) }}</p>
          <p v-if="supplyOrders" v-html="printSupplyStatus(order.related_order_id)"/>
        </td>
        <td>
          <div>
            {{ order.client_name }}
            <hr>
            <template v-if="order.order_phones.length">
              <p v-for="(phone) in order.order_phones">
                <strong v-html="printPhone(phone)"/>
              </p>
            </template>
            <template v-else>
              <p>{{ order.phone }}</p>
            </template>
          </div>
        </td>
        <td>
          <p>{{ order.address }}</p>
          <p>доставка: <strong>{{ moment(order.delivery_date) }}</strong></p>
        </td>
        <td>
          <div class="table_div" v-html="printDrugs(order.details)"/>
          <div class="text-right" v-if="permissions.allowToEditDrugs">
            <button class="btn btn-info btn-xs" @click="editDrugsModal(order, order.details)">Редактировать</button>
          </div>
        </td>
        <td>
          <div class="table_div" v-html="printComments(order.comment)"/>
          <div class="text-right" v-if="permissions.allowToComment">
            <button class="btn btn-success btn-xs" @click="addCommentModal(order)">Добавить</button>
          </div>
        </td>
        <td>
          <p><strong>{{ order.price }}</strong></p>
          <p v-if="rates && rates[38] && rates[38] != 1"><strong>({{
              Math.round(order.price * rates[38] * 10) / 10
            }})</strong></p>
        </td>
        <td>
          <button v-if="permissions.allowToReject" class="btn btn-warning btn-xs mb-1"
                  @click="addCommentModal(order, 'reject')">Отменить
          </button>
          <template v-if="permissions.allowToComplete">
            <template v-if="order.status === 4">
              <button class="btn btn-success btn-xs mb-1" @click="updateStatus(order, true)">Доставить</button>
              <button class="btn btn-outline-warning btn-xs mb-1" @click="updateStatus(order, true, true)">Отменить
              </button>
            </template>
            <span v-if="order.status === 5" class="badge badge-pill badge-success">Доставлено</span>
          </template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import api from '@/api'
import editDetailsModal from "../modals/orders/editDetailsModal";
import addCommentModal from "../modals/orders/addCommentModal";
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import moment from 'moment'

export default {
  components: {
    editDetailsModal,
    addCommentModal,
    VueLadda,
  },
  props: ['orders', 'updateOrderDetails', 'rates', 'viewType', 'supplyOrders'],
  data() {
    return {
      modalData: null,
      selected: {},
      closeOrderLoading: {},
      permissions: {
        allowToSelect: true,
        allowToEditDrugs: true,
        allowToComment: true,
        allowToReject: true,
        allowToComplete: false,
      }
    }
  },
  mounted() {
    if (this.viewType) {
      switch (this.viewType) {
        case 'moderating':
          this.permissions = {
            allowToSelect: false,
            allowToEditDrugs: false,
            allowToComment: true,
            allowToReject: false,
            allowToComplete: false,
          }
          break;
        case 'collectedOrders':
          this.permissions = {
            allowToSelect: false,
            allowToEditDrugs: false,
            allowToComment: true,
            allowToReject: false,
            allowToComplete: true,
          }
          break;
        default:
          break;
      }
    }
  },
  methods: {
    async updateStatus(order, modal = false, reject = false) {
      if (modal) {
        this.modalData = {
          order: order,
          type: reject ? 'reject' : 'status',
          header: reject ? 'Отменить заявку' : 'Закрыть заявку',
          text: reject ? 'Заявка будет отменена' : 'Заявка будет отмечена как доставлена',
          acceptBtnText: 'Подтвердить',
        };
      } else {
        let {data} = await api.post('/orders/updateNewOrder', {
          order: order,
          editType: 'status',
          status: 5,
        });

        if (data.success) {
          this.updateOrderDetails(this.viewType, order.id, 'status', 5);
        } else {
          toastr['warning'](data.message || 'Ошибка!');
        }
        this.closeModal();
      }
    },
    printSupplyStatus(orderId) {
      if (!this.supplyOrders || !this.supplyOrders[orderId]) {
        return '<span class="badge badge-pill badge-secondary">Не найдено</span>'
      }
      if (this.supplyOrders[orderId].status == 3 || this.supplyOrders[orderId].status == 11) {
        return '<span class="badge badge-pill badge-success">Доставлено</span>'
      }
      if (this.supplyOrders[orderId].status == 2) {
        return '<span class="badge badge-pill badge-info">В дороге</span>'
      }
      if (this.supplyOrders[orderId].status == -2 || this.supplyOrders[orderId].status == -3) {
        return '<span class="badge badge-pill badge-warning">Отменено</span>'
      }
      return '<span class="badge badge-pill badge-dark">Ожидает</span>'
    },
    addCommentModal(order, type = null) {

      let customData = {};

      switch (type) {
        case 'reject':
          customData.type = 'reject';
          customData.header = 'Отмена заявки';
          break;
        default:
          customData.type = 'comment';
          customData.header = 'Добавление комментария';
          break;
      }

      this.modalData = {
        type: customData.type,
        header: customData.header,
        acceptBtnText: 'Сохранить',
        order: order
      };
    },
    async addComment(text, type) {

      let {data} = await api.post('/orders/updateNewOrder', {
        editType: type === 'reject' ? 'runner_reject' : type,
        text: text,
        order: this.modalData.order,
      });
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка!');
      } else {
        if (this.updateOrderDetails) {
          if (type === 'comment') {
            this.updateOrderDetails(this.viewType, this.modalData.order.id, 'comment', data.comment);
          }
          if (type === 'reject') {
            this.updateOrderDetails(this.viewType, this.modalData.order.id, 'reject');
          }
        }
      }
      this.closeModal();
    },
    async updateOrderDetailsByType(drugs) {

      let {data} = await api.post('/orders/updateNewOrder', {
        editType: 'drugs',
        order: this.modalData.order,
        drugs: drugs
      });

      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка!');
      } else {
        if (this.updateOrderDetails) {
          this.updateOrderDetails(this.viewType, this.modalData.order.id, 'drugs', data.drugs);
          this.updateOrderDetails(this.viewType, this.modalData.order.id, 'price', data.price);
        }
        toastr['success']('Сохранено');

      }
      this.closeModal();

    },
    editDrugsModal(order, drugs) {
      this.modalData = {
        type: 'drugs',
        header: 'Редактирование препаратов',
        acceptBtnText: 'Отправить на проверку',
        rate: this.rates && this.rates[38] || 1,
        drugs: drugs,
        order: order
      };
    },
    closeModal() {
      this.modalData = null;
    },
    printDrugs(drugs) {
      let text = '';
      drugs.forEach((d) => {
        text += '<div><p>' + d.new_drug.title + '</p>';
        text += '<p><strong>' + (+d.new_drug.pack_set != 1 ? ((d.qty / +d.new_drug.pack_set) + '(к) x ' + (d.price * +d.new_drug.pack_set)) : (d.qty + ' x ' + d.price)) + '</strong>';
        if (this.rates && this.rates[38] && this.rates[38] != 1) {
          text += ' <strong>(' + Math.round(d.price * this.rates[38] * 10) / 10 + ')</strong>';
        }
        text += '</p></div>';
      })
      return text;
    },
    printComments(comments) {
      if (!comments) return;
      let text = '';
      comments.forEach((c) => {
        text += '<div><p>' + c.text + '</p><p class="text-muted">' + c.created_at + ': ' + c.user_name + '</p></div>';
      })
      return text;
    },
    printPhone(phone) {
      if (phone.phone && phone.phone.country_code) {
        return '<a href="tel:' + phone.full_phone + '">' + phone.phone.country_code + ' ' + phone.phone.phone + '</a>';
      } else {
        return '<a href="tel:' + phone.phone.phone + '">' + phone.phone.phone + '</a>';
      }
    },
    moment: function (date, format = 'DD.MM.YYYY') {
      if (!date) return;
      return moment(date).format(format);
    },
  }
}

</script>

<style scoped>


/*
Max width before this PARTICULAR table gets nasty. This query will take effect for any screen smaller than 760px and also iPads specifically.
*/
@media only screen
and (max-width: 760px), (min-device-width: 768px)
and (max-device-width: 1024px) {

  /* Force table to not be like tables anymore */
  table, thead, tbody, th, td, tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    margin: 0 0 1rem 0;
    border-bottom: 2px solid gray;
  }

  tr:nth-child(odd) {
    background: #f9f9f9;
  }

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #d4d4d4;
    position: relative;
    padding-left: 30%;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 0;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    font-size: 12px;
  }

  /*
  Label the data
  You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
  */
  td:nth-of-type(1):before {
    content: "Выбрать";
  }

  td:nth-of-type(2):before {
    content: "Номер заявки";
  }

  td:nth-of-type(3):before {
    content: "Клиент";
  }

  td:nth-of-type(4):before {
    content: "Адрес";
  }

  td:nth-of-type(5):before {
    content: "Препараты";
  }

  td:nth-of-type(6):before {
    content: "Комментарии";
  }

  td:nth-of-type(7):before {
    content: "Сумма";
  }

  td:nth-of-type(8):before {
    content: "";
  }

}

.orders_profile_table p {
  margin-bottom: 2px;
}

.orders_profile_table .text-muted {
  font-size: 10px;
}

hr {
  margin-bottom: 3px;
  margin-top: 3px;
}

.btn-xs {
  padding: 3px 10px !important;
}
</style>
<style>
.orders_profile_table .table_div p {
  margin-bottom: 2px;
}

.orders_profile_table .text-muted {
  font-size: 10px;
}

.orders_profile_table p {
  margin-bottom: 2px;
}
</style>
